

































































































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/order/orderLogs/index'
import { FormItem } from '../../../types/iview/form'
@Component({
  components: {
    CustomForm,
  },
})
export default class OrderReconciliation extends AbpBase {
  filters = [
    {
      label: '订单编号',
      type: 'input',
      props: {
        placeholder: '请输入订单编号',
      },
      key: 'tradeNo',
    },
    {
      label: '对账状态',
      type: 'select',
      props: {
        placeholder: '请选择对账状态',
      },
      key: 'checkStatus',
      options: [
        {
          value: 0,
          text: '未对账',
        },
        {
          value: 1,
          text: '已对账',
        },
        {
          value: 2,
          text: '异常',
        },
        {
          value: 3,
          text: '冲正',
        },
      ],
    },
    {
      label: '开始时间',
      type: 'date',
      props: {
        placeholder: '请选择开始日期',
      },
      key: 'startTime',
    },
    {
      label: '结束时间',
      type: 'date',
      props: {
        placeholder: '请选择结束日期',
      },
      key: 'endTime',
    },
  ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '下单时间',
      key: 'creationTime',
      align: 'center',
      width: 200,
    },
    {
      title: '支付时间',
      key: 'payTime',
      align: 'center',
      width: 200,
    },
    {
      title: '发货时间',
      key: 'deliveryTime',
      align: 'center',
      width: 200,
    },
    {
      title: '订单号',
      key: 'orderNo',
      width: 200,
      align: 'center',
    },
    {
      title: '商品类别',
      slot: 'categoryName',
      align: 'center',
      width: 200,
    },
    {
      title: '商品名称',
      slot: 'productName',
      align: 'center',
      width: 250,
    },
    {
      title: '商品代码',
      slot: 'productCode',
      align: 'center',
      width: 160,
    },
    {
      title: '规格代码',
      slot: 'skuCode',
      align: 'center',
      width: 160,
    },
    {
      title: '商品规格',
      slot: 'skuName',
      align: 'center',
      width: 200,
    },
    {
      title: '销售数量',
      slot: 'quantity',
      align: 'center',
      width: 120,
    },
    //   {
    //   title: '是否是赠品',
    //   key: 'IsGift',
    //   align: 'center',
    //   width: 100
    // },
    // {
    //   title: '退货数量',
    //   slot: 'returnQuantity',
    //   align: 'center',
    //   width: 250
    // },
    {
      title: '商品单价',
      slot: 'price',
      align: 'center',
      width: 120,
    },
    {
      title: '商品实收单价',
      slot: 'promotionPrice',
      align: 'center',
      width: 120,
    },
    {
      title: '商品实收单价总额',
      slot: 'promotionPriceTotal',
      align: 'center',
      width: 150,
    },
    {
      title: '优惠金额',
      slot: 'discountAmount',
      align: 'center',
      width: 120,
    },
    {
      title: '退款金额',
      slot: 'refundAmount',
      align: 'center',
      width: 120,
    },
    {
      title: '积分抵扣',
      slot: 'totalPoints',
      align: 'center',
      width: 200,
    },
    {
      title: '运费',
      key: 'shippingFee',
      align: 'center',
      width: 120,
    },
    {
      title: '商品活动',
      slot: 'productPromotionName',
      align: 'center',
      width: 150,
    },
    {
      title: '促销活动',
      slot: 'promotionName',
      align: 'center',
      width: 150,
    },
    {
      title: '优惠券活动',
      slot: 'couponPromotionName',
      align: 'center',
      width: 150,
    },
    {
      title: '实收总金额',
      key: 'payAmount',
      align: 'center',
      width: 120,
    },
    {
      title: '订单来源',
      key: 'orderSourceType',
      align: 'center',
      width: 200,
    },
    {
      title: '支付方式',
      key: 'paymentMethod',
      align: 'center',
      width: 150,
    },
    {
      title: '订单状态',
      key: 'orderFullStatusStr',
      align: 'center',
      width: 100,
    },
    {
      title: '发货状态',
      key: 'shippingStatus',
      align: 'center',
      width: 100,
    },
    {
      title: '退款及退货',
      slot: 'refundType',
      align: 'center',
      width: 120,
    },
    {
      title: '申请状态',
      slot: 'refundStatus',
      align: 'center',
      width: 120,
    },
    {
      title: '物流公司',
      key: 'expressCompanyName',
      align: 'center',
      width: 200,
    },
    {
      title: '收件人',
      key: 'name',
      align: 'center',
      width: 200,
    },
    {
      title: '收货地址',
      key: 'address',
      align: 'center',
      width: 300,
    },
    {
      title: '联系电话',
      key: 'phone',
      align: 'center',
      width: 200,
    },
    {
      title: '邮编',
      key: 'zipCode',
      align: 'center',
      width: 200,
    },
    {
      title: '物流单号',
      key: 'shipmentNumber',
      align: 'center',
      width: 200,
    },
    {
      title: '买家会员',
      key: 'nickName',
      align: 'center',
      width: 200,
    },
    {
      title: '会员手机',
      key: 'phoneNumber',
      align: 'center',
      width: 200,
    },
    {
      title: '会员等级',
      key: 'level',
      align: 'center',
      width: 200,
    },
    {
      title: '直接销售',
      slot: 'directPercent',
      align: 'center',
      width: 200,
    },
    {
      title: '直接导购ID',
      slot: 'employeeCode',
      align: 'center',
      width: 200,
    },
    {
      title: '直接导购信息',
      slot: 'employeeInfo',
      align: 'center',
      width: 350,
    },
    {
      title: '直接导购姓名',
      slot: 'employeeName',
      align: 'center',
      width: 200,
    },
    {
      title: '间接销售',
      slot: 'indirectPercent',
      align: 'center',
      width: 200,
    },
    {
      title: '间接导购ID',
      slot: 'indirectEmployeeCode',
      align: 'center',
      width: 200,
    },
    {
      title: '间接导购信息',
      slot: 'indirectEmployeeInfo',
      align: 'center',
      width: 350,
    },
    {
      title: '间接导购姓名',
      slot: 'indirectEmployeeName',
      align: 'center',
      width: 200,
    },
    {
      title: '对账人员',
      key: 'checker',
      align: 'center',
      width: 200,
    },
    {
      title: '对账时间',
      key: 'checkTime',
      align: 'center',
      width: 200,
    },
    {
      title: '对账状态',
      key: 'checkStatus',
      align: 'center',
      width: 200,
    },
    {
      title: '流水备注',
      key: 'description',
      align: 'center',
      width: 200,
    },
  ]
  data = []
  copyData = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  exporting: boolean = false

  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  paymentMethodDisplayName(paymentMethod) {
    switch (paymentMethod) {
      case 0:
        return '支付宝'
      case 1:
        return '微信支付'
      default:
        return ''
    }
  }
  checkStatusDisplayName(status) {
    switch (status) {
      case 0:
        return '未对账'
      case 1:
        return '已对账'
      case 2:
        return '异常'
      case 3:
        return '已冲正'
      default:
        return ''
    }
  }
  view(id) {
    this.$router.push({ name: 'reconciliationDetail' })
  }
  updateCheckStatus(checkStatus: number) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length <= 0) {
      this.$Message.warning('请选择提现记录')
    }
    let ids = selection.map((t) => t.id)
    Api.updateCheckStatus({
      ids: ids,
      checkStatus: checkStatus,
      remark: '',
    }).then((res) => {
      this.$Message.success('操作成功')
      this.loadData((this.$refs.lineForm as any).form)
    })
  }
  loadData(form = {}) {
    let tradeNo = form['tradeNo']
    let range = form['amountRange']
    let upper = null
    let lower = null
    if (range) {
      var arr = range.split('~')
      upper = arr[0]
      lower = arr[1]
    }
    let checkStatus = form['checkStatus']
    let startTime = form['startTime'] ? this.dateString(form['startTime']) : null
    let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    // console.log(startTime, endTime);
    Api.getList2(this.pager.pageSize, this.pager.pageIndex, tradeNo, checkStatus, startTime, endTime).then((res) => {
      console.log('对账单数据', res)
      this.pager.total = res.data.totalCount
      this.data = res.data.items
      this.copyData = this._integratedData(res.data.items)
    })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    this.pager.pageIndex = 1
    form.submit()
  }
  setSuccess() {
    this.updateCheckStatus(1)
  }
  setException() {
    this.updateCheckStatus(2)
  }
  setAverage() {
    this.updateCheckStatus(3)
  }

  // 表格合并
  handleSpan({ row, column, rowIndex, columnIndex }) {
    if (
      (0 < columnIndex && columnIndex < 5) ||
      (columnIndex > 16 && columnIndex < 18) ||
      (columnIndex > 19 && columnIndex < 25) ||
      (columnIndex > 26 && columnIndex < 36) ||
      (columnIndex > 43 && columnIndex < 48)
    ) {
      return {
        rowspan: row.mergeCol === 0 ? 0 : row.mergeCol,
        colspan: row.mergeCol === 0 ? 0 : 1,
      }
    }
  }
  // 处理数据
  _integratedData(data) {
    var lastArr = []
    data.forEach((item, firstIndex) => {
      item.orderItems.forEach((innerItem, attrIndex) => {
        lastArr.push(
          Object.assign({}, item, {
            mergeCol: attrIndex === 0 ? item.orderItems.length : 0,
            orderInfo: innerItem,
          })
        )
      })
    })
    return lastArr
  }
  exportExcel() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let tradeNo = form['tradeNo']
    let checkStatus = form['checkStatus']
    let startTime = form['startTime']
    let endTime = form['endTime']
    Api.exportExcel(this.pager.pageSize, this.pager.pageIndex, tradeNo, checkStatus, startTime, endTime)
      .then((res) => {
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  exportExcelSync() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    let tradeNo = form['tradeNo']
    let checkStatus = form['checkStatus']
    let startTime = form['startTime']
    let endTime = form['endTime']
    Api.exportExcelSyncReconcliation(
      this.pager.pageSize,
      this.pager.pageIndex,
      tradeNo,
      checkStatus,
      startTime,
      endTime
    )
      .then((res) => {
        this.exporting = false
        this.$router.push({
          name: 'exportExcelRecord'
        })
      })
      .catch((err) => {
        this.exporting = false
      })
  }

  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '对账单列表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
